// Static marketing copy from the template (live data comes from the API).
export const funnelSteps = [
  {
    stage: "01 — Awareness",
    title: "Start with the free content",
    body: "Discover the Academy through our YouTube library or download the Tier by Tier property book.",
  },
  {
    stage: "02 — Acquisition",
    title: "Join the portal for £10/mo",
    body: "Unlock the segmented video library and the AI Deal Analyzer from day one.",
  },
  {
    stage: "03 — Nurturing",
    title: "Accelerate with a Strategy Hour",
    body: "Hit a roadblock? Book a £299 strategy hour or step up to a Bronze or Silver scheme.",
  },
  {
    stage: "04 — High Ticket",
    title: "Scale with Gold or Platinum VIP",
    body: "Hands-on mentorship, JV structuring, and a sourcing team that builds your portfolio for you.",
  },
] as const;

/** Deal sourcing calls go to WhatsApp (the contact form stays for everything else). */
export const sourcingWhatsApp = {
  number: "442071834412",
  display: "+44 20 7183 4412",
  message: "Hello, I would like to request a deal sourcing call.",
};

export const sourcingWhatsAppUrl = `https://wa.me/${sourcingWhatsApp.number}?text=${encodeURIComponent(sourcingWhatsApp.message)}`;
